import { render, staticRenderFns } from "./tavern.vue?vue&type=template&id=c4c3289a&scoped=true&"
import script from "./tavern.vue?vue&type=script&lang=js&"
export * from "./tavern.vue?vue&type=script&lang=js&"
import style0 from "./tavern.vue?vue&type=style&index=0&id=c4c3289a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c3289a",
  null
  
)

export default component.exports